const FAILSAFE_TIMEOUT = 3500
if (typeof window !== 'undefined') {
  window.pbjs = window.pbjs || { que: [] }
  window.googletag = window.googletag || { cmd: [] }
}
// example function to call whenever a DM header bidding auction is required
export function demandManagerRequest(slots: any[]) {
  // provide failsafeHandler with callback function to fire when we want to make
  // the ad server request, as well as headerBiddingSlots to use in case of failsafe
  const sendAdServerRequest = failsafeHandler((slotsToRefresh: any) => {
    window.googletag.pubads().refresh(slotsToRefresh)
  }, slots)

  // request bids when PBJS is ready
  window.pbjs.que.push(function () {
    window.pbjs.rp.requestBids({
      callback: sendAdServerRequest,
      gptSlotObjects: slots,
    })
  })

  // start the failsafe timeout
  setTimeout(sendAdServerRequest, FAILSAFE_TIMEOUT)

  // function that handles the failsafe using boolean logic per auction
  function failsafeHandler(callback: any, initialSlots: any) {
    let adserverRequestSent = false
    return (bidsBackSlots: any) => {
      if (adserverRequestSent) return
      adserverRequestSent = true
      callback(bidsBackSlots || initialSlots)
    }
  }
}
